/* Mabrouka — livraison : délai calculé à l'heure d'Israël + vérificateur de ville « משלוח באותו יום ».
   Lit la config émise par snippets/mbr-shipping.liquid. Ré-initialise les blocs injectés plus tard
   (drawer du panier) grâce à un MutationObserver. */
(function () {
  'use strict';
  if (window.__mbrShip) return;
  window.__mbrShip = true;

  var DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  // English pages (/en): same calculation, English wording. Set per block from the config (cfg.lang).
  var DAYS_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var EN = false;
  var CITY_KEY = 'mbr_city';

  // GA4 via the gtag the Google & YouTube app puts on the page (see mbr-bundle.js).
  function track(name, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data || {}); } catch (e) {}
    // Microsoft Clarity (app Shopify, tag uypy484dkc): the event lets recordings be filtered by it, the
    // tags let heatmaps be segmented (pack, tier, city eligibility). value/currency are not worth a tag.
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        Object.keys(data || {}).forEach(function (k) { if (k !== 'value' && k !== 'currency') window.clarity('set', k, String(data[k])); });
      }
    } catch (e) {}
  }

  function israelNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' })); }
    catch (e) { return new Date(); }
  }
  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function readConfig(root) {
    var el = root.querySelector('[data-mbr-ship-config]') || document.querySelector('[data-mbr-ship-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function parseList(s) {
    return String(s || '').split(/[,\n]/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function isBusinessDay(d, holidays) {
    var wd = d.getDay();
    if (wd === 5 || wd === 6) return false;
    return holidays.indexOf(ymd(d)) === -1;
  }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function nextBusinessDay(d, holidays) {
    var x = addDays(d, 1);
    while (!isBusinessDay(x, holidays)) x = addDays(x, 1);
    return x;
  }
  function addBusinessDays(d, n, holidays) {
    var x = new Date(d), c = 0;
    while (c < n) { x = addDays(x, 1); if (isBusinessDay(x, holidays)) c++; }
    return x;
  }
  function dayDiff(now, d) {
    return Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  }
  function dayLabel(now, d) {
    var diff = dayDiff(now, d);
    if (EN) {
      if (diff === 0) return 'today';
      if (diff === 1) return 'tomorrow';
      return DAYS_EN[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1);
    }
    if (diff === 0) return 'היום';
    if (diff === 1) return 'מחר';
    return 'יום ' + DAYS[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1);
  }
  // « ביום שני 14.9 » — with the preposition, for « יוצא … »
  function onDay(now, d) {
    if (EN) return dayDiff(now, d) <= 1 ? dayLabel(now, d) : 'on ' + dayLabel(now, d);
    return dayDiff(now, d) <= 1 ? dayLabel(now, d) : 'ב' + dayLabel(now, d);
  }

  function etas(cfg) {
    EN = cfg.lang === 'en';
    var now = israelNow();
    var holidays = parseList(cfg.holidays);
    var parts = String(cfg.cutoff || '08:30').split(':');
    var cutoff = new Date(now); cutoff.setHours(+parts[0] || 8, +parts[1] || 30, 0, 0);
    var beforeCutoff = isBusinessDay(now, holidays) && now < cutoff;
    var express, standard;
    if (beforeCutoff) {
      var mins = Math.max(1, Math.round((cutoff - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      if (EN) {
        var leftEn = h > 0 ? ((h === 1 ? '1 hour' : h + ' hours') + (m ? ' ' + m + ' min' : '')) : (m + ' min');
        express = 'Order within ' + leftEn + ' and get it <b>today</b>';
      } else {
        var left = h > 0 ? ((h === 1 ? 'שעה' : h + ' שעות') + (m ? ' ו‑' + m + ' דקות' : '')) : (m + ' דקות');
        express = 'הזמינו ב‑' + left + ' הקרובות ותקבלו <b>היום</b>';
      }
    } else {
      var nb = nextBusinessDay(now, holidays);
      express = EN ? 'Order now and get it <b>' + onDay(now, nb) + '</b>' : 'הזמינו עכשיו ותקבלו <b>' + onDay(now, nb) + '</b>';
    }
    // Standard: ships on the next business day (today before cutoff). The shipping day counts as
    // day 1. The customer sees the DISPATCH day and the USUAL arrival (typicalDays, what the carrier
    // really does) first; the committed maximum ("1‑5") only appears as « לכל המאוחר ». Leading
    // with the latest date made a normal delivery look slow (Jeremy, 10.9.2026).
    var startsToday = isBusinessDay(now, holidays) && now < cutoff;
    var shipDay = startsToday ? now : nextBusinessDay(now, holidays);
    var maxDays = 5;
    var mm = String(cfg.standardDays || '').match(/(\d+)\s*$/);
    if (mm) maxDays = +mm[1];
    var typDays = Math.min(maxDays, Math.max(1, +cfg.typicalDays || 3));
    var usual = addBusinessDays(shipDay, typDays - 1, holidays);
    var last = addBusinessDays(shipDay, maxDays - 1, holidays);
    // Was dispatch pushed back by a holiday (not just by the weekend)? Then say so: a date that
    // looks late because of ראש השנה is not a slow courier.
    var plainShip = (isBusinessDay(now, []) && now < cutoff) ? now : nextBusinessDay(now, []);
    var pushed = ymd(plainShip) !== ymd(shipDay);
    if (EN) {
      standard = (pushed ? 'Because of the holiday, ships <b>' : 'Ships <b>') + onDay(now, shipDay) + '</b> · expected by <b>' + dayLabel(now, usual) + '</b>';
      if (ymd(last) !== ymd(usual)) standard += ' <span class="mbr-ship__max">(' + dayLabel(now, last) + ' at the latest)</span>';
    } else {
      standard = (pushed ? 'בגלל החג יוצא רק <b>' : 'יוצא <b>') + onDay(now, shipDay) + '</b> · צפוי להגיע עד <b>' + dayLabel(now, usual) + '</b>';
      if (ymd(last) !== ymd(usual)) standard += ' <span class="mbr-ship__max">(לכל המאוחר ' + dayLabel(now, last) + ')</span>';
    }
    return { express: express, standard: standard };
  }

  function initBlock(block) {
    if (block.dataset.mbrShipInit) return;
    block.dataset.mbrShipInit = '1';
    var cfg = readConfig(block);
    if (!cfg) return;
    var e = etas(cfg);
    var ex = block.querySelector('[data-eta-express]');
    var st = block.querySelector('[data-eta-standard]');
    if (ex) ex.innerHTML = e.express;
    if (st) st.innerHTML = e.standard;

    var input = block.querySelector('[data-city-input]');
    if (!input) return;
    var list = block.querySelector('[data-city-list]');
    var result = block.querySelector('[data-city-result]');
    var cities = parseList(cfg.cities);
    var label = cfg.expressLabel || 'משלוח באותו יום';

    function normalize(s) { return String(s || '').trim().replace(/\s+/g, ' '); }
    // fromUser: only an explicit check is an event; restoring the saved city on page load is not.
    function show(city, fromUser) {
      var ok = cities.some(function (c) { return normalize(c) === normalize(city); });
      if (fromUser) track('shipping_city_check', { city: normalize(city), same_day: ok ? 'yes' : 'no' });
      if (ok) {
        result.className = 'mbr-ship__result is-ok';
        result.innerHTML = '✓ ' + label + ' זמין ב' + normalize(city) + ' · ' + e.express;
      } else {
        result.className = 'mbr-ship__result is-no';
        result.innerHTML = 'ב' + normalize(city) + ': משלוח רגיל · ' + e.standard;
      }
      try { localStorage.setItem(CITY_KEY, normalize(city)); } catch (err) {}
    }
    function suggest() {
      var q = normalize(input.value);
      if (q.length < 1) { list.hidden = true; list.innerHTML = ''; return; }
      var hits = cities.filter(function (c) { return c.indexOf(q) === 0; })
        .concat(cities.filter(function (c) { return c.indexOf(q) > 0; })).slice(0, 6);
      if (!hits.length) { list.hidden = true; list.innerHTML = ''; return; }
      list.innerHTML = hits.map(function (c) { return '<button type="button" data-city="' + c.replace(/"/g, '&quot;') + '">' + c + '</button>'; }).join('');
      list.hidden = false;
    }
    input.addEventListener('input', suggest);
    input.addEventListener('focus', suggest);
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); submit(); }
      if (ev.key === 'Escape') list.hidden = true;
    });
    // Explicit "check" button: same as Enter — first suggestion if it matches what was typed, else the text itself.
    function submit() {
      var q = normalize(input.value);
      if (!q) { input.focus(); return; }
      var first = list.querySelector('[data-city]');
      var pick = (first && !list.hidden) ? first.dataset.city : q;
      input.value = pick;
      show(pick, true);
      list.hidden = true;
    }
    var go = block.querySelector('[data-city-go]');
    if (go) go.addEventListener('click', submit);
    list.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-city]');
      if (!b) return;
      input.value = b.dataset.city;
      list.hidden = true;
      show(b.dataset.city, true);
    });
    document.addEventListener('click', function (ev) { if (!block.contains(ev.target)) list.hidden = true; });

    var check = block.querySelector('[data-check]');
    var toggle = block.querySelector('[data-check-toggle]');
    if (toggle) toggle.addEventListener('click', function () { check.classList.remove('is-folded'); input.focus(); });
    var saved = null;
    try { saved = localStorage.getItem(CITY_KEY); } catch (err) {}
    if (saved) { input.value = saved; show(saved); if (check) check.classList.remove('is-folded'); }
  }

  function boot() { document.querySelectorAll('[data-mbr-ship]').forEach(initBlock); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  if (window.MutationObserver) {
    new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', boot);
})();
